// @vendors
import React from 'react';
import { useTranslation } from 'react-i18next';

// @components
import CategoriesGrid from './components/CategoriesGrid';

const CategoriesPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center pb-6 px-4">
      <h1 className="text-[22px] font-semibold text-cText dark:text-dark-cText mb-6">{t("categoriesPage.title")}</h1>
      <CategoriesGrid />
    </div>
  );
};

export default CategoriesPage;